import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry() {
  if (!dsn) return; // Quietly skip when DSN is not configured (e.g. local dev)

  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const isPreview = host.includes("lovable.app") || host.includes("lovableproject.com");
  const isLocal = host === "localhost" || host === "127.0.0.1";
  if (isLocal) return; // never report from local dev

  Sentry.init({
    dsn,
    environment: isPreview ? "preview" : "production",
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    // Error monitoring only — no performance tracing or session replay.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
  });
}

export { Sentry };